export default __webpack_public_path__ + "media/images/backgrounds/pumpkins-ef73bc707e7928d91760d65e8da07f48.svg";